import {
	Component,
	OnChanges,
	Input,
	Output,
	ViewChild,
	TemplateRef,
	ViewEncapsulation,
	EventEmitter,
	OnDestroy
} from '@angular/core';
import { IdService } from '../../shared/services/id.service';
import { TIconType } from '../icon/icon.types';
import {
	TButtonType,
	TButtonColor,
	TButtonChevron,
	TButtonSize,
	TButtonLoadingType,
	TButtonFullWidth
} from './button.types';

@Component({
	selector: 'rbc-button',
	templateUrl: './button.component.html',
	styleUrls: ['./button.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class ButtonComponent implements OnChanges, OnDestroy {
	// Private Members
	id: string;
	isLoading = false;
	width: string;

	// Input Parameters
	@Input() type: TButtonType = '';
	@Input() color: TButtonColor = 'primary';
	@Input() outline: boolean = false;
	@Input() chevron: TButtonChevron;
	@Input() disabled: boolean = false;
	@Input() size: TButtonSize;
	@Input() fullWidth: TButtonFullWidth = false;
	@Input() icon: string = '';
	@Input() iconWeight: TIconType = 'regular';
	@Input() link: string;
	@Input() loading: boolean = false;
	@Input() loadingType: TButtonLoadingType = 'full';
	@Input() routerLink: string | any[];
	@Input() queryParams: { [key: string]: string };

	@Output() buttonClick = new EventEmitter();
	@Output() buttonFocus = new EventEmitter();
	@Output() buttonMouseOver = new EventEmitter();
	@Output() buttonMouseOut = new EventEmitter();

	@ViewChild('buttonContents') ref: TemplateRef<any>;

	constructor(private idService: IdService) {
		this.id = idService.generate();
	}

	ngOnDestroy(): void {
		this.idService.remove(this.id);
	}

	ngOnChanges() {
		this.isLoading = this.loading;
	}

	calculateClasses() {
		const classes = {};
		classes['button'] = true;
		classes[`button-${this.size}`] = this.size;
		classes[`button-${this.color}`] = this.color && !this.outline;
		classes[`button-${this.color}-outline`] = this.outline;
		classes[`button-chev-${this.chevron}`] = this.chevron === 'up' || this.chevron === 'down';
		classes[`button-chev`] = this.chevron === 'right';
		classes['button-block'] = this.fullWidth && this.fullWidth !== 'mobile';
		classes['button-block-xs'] = this.fullWidth && this.fullWidth === 'mobile';
		classes['button-loading'] = this.isLoading && this.loadingType === 'full';
		classes['button-loading-inline'] = this.isLoading && this.loadingType === 'inline';
		classes['button-icon'] = (this.icon || this.chevron) && !this.hasContent();
		classes[`button-${this.type}`] = this.type && this.type !== 'submit' && this.type !== 'reset';

		return classes;
	}

	hasContent() {
		const element = this.ref.elementRef.nativeElement.previousElementSibling;

		if (element && element.textContent.trim() !== '') {
			return true;
		}

		return false;
	}
}
